module.exports = __webpack_public_path__ + "static/media/anime404.f5230813.gif";